

































import Directory from './directory.vue'
import Practice from './practice.vue'
import Faqs from './faqs.vue'
import Note from './note.vue'
import Comment from './commet.vue'
import { Component, Emit, Vue } from 'vue-property-decorator'
import LearningCourseModule from '@api/module/customer/learning/LearningCourseModule'
import LearningCourseWare from '@api/model/learning/LearningCourseWare'

@Component({
  components: {
    Directory,
    Faqs,
    Note,
    Comment,
    Practice
  }
})
export default class extends Vue {
  get learningCourse() {
    return LearningCourseModule.learningCourse
  }

  type = 'Directory'
  tabMenu: Array<object> = [
    // new Tab('Directory', '目录'),
    // new Tab('Practice', '练习'),
    // new Tab('Note', '笔记'),
    // new Tab('Faqs', '答疑'),
    // new Tab('Comment', '评价')
  ]

  get teacherNames() {
    return this.learningCourse.teacherList.map((teacher: any) => teacher.name).join('、')
  }

  get isAlreadyUpdateComplete() {
    return this.learningCourse.alreadyUpdateLecture > this.learningCourse.totalLecture
  }

  toggle(event: MouseEvent) {
    event.preventDefault()
    if (event.target) {
      const { type = this.type } = (event.target as HTMLElement).dataset
      this.type = type
    }
  }

  @Emit('change-courseware')
  changeCourseWare(courseWare: LearningCourseWare) {
    console.log(courseWare)
  }
}
